import { createContext } from 'react';
import { customValidator } from 'data/validation/validators';
import validateJs from 'validate.js';

import { ERROR_CODE } from '@config/errors';

import { dateTimeRangeValidator } from '@validation/validators';

import { IValidator } from './types';
import { Validator } from './validator';

/**
 * @todo
 * Reconsider using singleton here.
 * The better approach is passing created validator object via ReactContext and
 * getting it via a hook.
 * As an example see initialization of navigator object in _app.js
 */
let _validator: undefined | IValidator;

export const initializeValidator = (): IValidator => {
  if (_validator) {
    return _validator;
  }

  validateJs.validators.presence.message = ERROR_CODE.FIELD_REQUIRED;
  validateJs.validators.custom = customValidator;
  validateJs.validators.dateTimeRange = dateTimeRangeValidator;

  _validator = new Validator({ validator: validateJs });

  return _validator;
};

export const ValidatorContext = createContext<IValidator>({} as IValidator);
